import React, { Component } from 'react';
import { Slider, Rail, Handles, Tracks, Ticks } from 'react-compound-slider';
import Handle from './Handle';
import Track from './Track';
import Tick from './Tick';
import SliderRail from './SliderRail';

const sliderStyle = {  // Give the slider some width
    position: 'relative',
    width: '100%',
    height: 65,
  }
  const sliderSupriseStyle = {  // Give the slider some width
    position: 'relative',
    width: '90%',
    height: 65,
    margin: 'auto'

  }
export default class ScoreSlider extends Component {
  constructor(props) {
    super(props);
    this.state={
      domain:[0,10]
    }

    if(props.from){
      if(props.from==="suprise"){
        this.state={
          domain:[1,5]
        }
      }
    }


  }
    onChange = (value) => {
      // console.log("ScoreSlider Change");
      this.props.onChange(value);
    }
    onUpdate = (value) => {
      // console.log("ScoreSlider onUpdate");
      if(this.props.from){
        if(this.props.from==="suprise"){
      this.props.onUpdate(value);}
        }
    }
    onSlideStart = (value) => {
      if(this.props.from){
        if(this.props.from==="suprise"){
      this.props.onSlideStart(value);}}
    }
    onSlideEnd = (value) => {
      if(this.props.from){
        if(this.props.from==="suprise"){
      this.props.onSlideEnd(value);}}
    }
    render() {
        return (
        <div className="ScoreSlider">
            <Slider
            rootStyle={this.props.from==='suprise'?sliderSupriseStyle:sliderStyle}
            domain={this.state.domain}
            step={1}
            mode={5}
            values={this.props.value}
            onChange={this.onChange}
            onUpdate={this.onUpdate}
            onSlideStart={this.onSlideStart}
            onSlideEnd={this.onSlideEnd}
            disabled={this.props.disabled}
          >
            <Rail>
              {({ getRailProps }) => (
                <SliderRail getRailProps={getRailProps} />
              )}
            </Rail>
            <Handles>
              {({ handles, getHandleProps }) => (
                <div className="slider-handles">
                  {handles.map(handle => (
                    <Handle
                      key={handle.id}
                      handle={handle}
                      disabled={this.props.disabled}
                      getHandleProps={getHandleProps}
                    />
                  ))}
                </div>
              )}
            </Handles>
            <Tracks left={false} right={false}>
              {({ tracks, getTrackProps }) => (
                <div className="slider-tracks">
                  {tracks.map(({ id, source, target }) => (
                    <Track
                      key={id}
                      source={source}
                      target={target}
                      disabled={this.props.disabled}
                      getTrackProps={getTrackProps}
                    />
                  ))}
                </div>
              )}
            </Tracks>
            <Ticks count={1}>
                {({ ticks }) => (
                <div className="slider-ticks">
                    {ticks.map(tick => (
                    <Tick key={tick.id} tick={tick} count={ticks.length} />
                    ))}
                </div>
                )}
            </Ticks>
          </Slider>

        </div>
        )
    }
}